import { NavLink } from 'react-router-dom';
import { useFavorites } from '../favorites';
import { usePulse } from '../motion';

/**
 * Odkaz na oblíbené v hlavičce s počítadlem.
 *
 * Počítadlo pulzuje, když oblíbených přibude – stejné potvrzení jako
 * u košíku, na místě, kam se zákazník právě dívá.
 */
export function FavoritesLink() {
  const { count } = useFavorites();
  const pulsing = usePulse(count);

  return (
    <NavLink
      to="/oblibene"
      className={({ isActive }) => (isActive ? 'fav-link active' : 'fav-link')}
      aria-label={`Oblíbené${count > 0 ? ` (${count})` : ''}`}
    >
      <svg viewBox="0 0 24 24" width="19" height="19" aria-hidden="true" focusable="false">
        <path
          d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
          fill={count > 0 ? 'currentColor' : 'none'}
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className="fav-label">Oblíbené</span>
      {count > 0 && (
        <span className={pulsing ? 'fav-count is-pulsing' : 'fav-count'}>{count}</span>
      )}
    </NavLink>
  );
}
